module.exports = __webpack_public_path__ + "static/media/produtos-banner.3497370f.jpg";